import { Button } from '@material-ui/core';
import { ButtonProps } from '@material-ui/core/Button';
// import { darken } from '@material-ui/core/styles';

import styled, { css, DefaultTheme, CSSObject } from 'styled-components';

const roundedProps = {
  none: 'none',
  basic: '10px',
  hard: '50px',
  'basic-left': '10px 0 0 10px',
  'basic-right': '0 10px 10px 0',
  'basic-bottom': '0 0 10px 10px',
};

type StyleProps = {
  width?: string;
  height?: string;
  typography?: keyof DefaultTheme['typography'];
  rounded?: 'none' | 'basic' | 'hard' | 'basic-left' | 'basic-right' | 'basic-bottom';
  border?: boolean;
  secondaryColor?: boolean;
  tertiaryColor?: boolean;
  topRightRadius?: string;
  bottomRightRadius?: string;
  topLeftRadius?: string;
  bottomLeftRadius?: string;
  fontSize?: string;
  // https://github.com/mui-org/material-ui/issues/15695
  [index: string]: any;
};

const secondaryColor = css`
  background: #f44336;
  &:hover {
    background: #ba000d;
  }
`;

const tertiaryColor = css`
  background: transparent;
  border: 1px solid #707070;
  /* border-top-right-radius: 4px;
  border-bottom-right-radius: 4px; */
  color: #707070;
  &:hover {
    border: darken(#707070, 0.2);
    color: darken(#707070, 0.2);
    background: transparent;
  }
`;

/* eslint-disable */
export const StyledButton = styled(Button).withConfig({
  shouldForwardProp: props => !['secondaryColor'].includes(props),
})<StyleProps>`
  ${p => css(p.theme.typography[p.typography || 'h5'] as CSSObject)};
  flex-direction: row;
  gap: 1rem;
  align-items: center;
  background: #36beb6;
  height: ${p => p.height || '47px'};
  min-width: ${p => p.width || '40%'};
  font-size: 16px;
  font-weight: bold;
  border-radius: ${p => roundedProps[p.rounded || 'none']};
  border-top-right-radius: ${p => p.topRightRadius || '4px'};
  border-bottom-right-radius: ${p => p.bottomRightRadius || '4px'};
  border-top-left-radius: ${p => p.topLeftRadius || '4px'};
  border-bottom-left-radius: ${p => p.bottomLeftRadius || '4px'};
  font-size: ${p => p.fontSize || '16px'}
  ${p => p.secondaryColor && !p.disabled && secondaryColor}
  ${p => p.tertiaryColor && !p.disabled && tertiaryColor}
` as React.ComponentType<StyleProps & ButtonProps>;
